<script lang="ts">
import { defineComponent, PropType } from "vue";
import { injectOut } from "@/shared/utils/injection";
import KlereoSlider from "@/shared/components/KlereoSlider.vue";

export default defineComponent({
  ...injectOut,
  components: {
    KlereoSlider,
  },
  props: {
    range: {
      required: true,
      type: Array as unknown as PropType<[number, number]>,
    },
    unit: {
      required: true,
      type: String,
    },
  },
});
</script>

<template>
  <div>
    <p>{{ $t("Duree") }} ({{ $t(unit) }}) :</p>

    <klereo-slider
      v-model="out.newOffDelay"
      :min="range[0]"
      :max="range[1]"
      :precision="1"
    />
  </div>
</template>
